import styled from 'styled-components'

export const MainContainer = styled.div`
  color: #303032;
  text-align: center;

  font-family: Barlow;
  font-size: 24px;
  font-weight: 400;
  line-height: 32px;

  @media (min-width: 768px) {
    font-size: 32px;
    line-height: 48px; /* 150% */
  }
`

export const HighlightSpan = styled.span<{ $color: string }>`
  color: ${(props) => props.$color};
  font-weight: 600;
`
